import { Component } from '@angular/core';

@Component({
  selector: 'asw-hello-world-cont',
  templateUrl: './hello-world-cont.component.html',
})
export class HelloWorldContComponent {}
